const map = {
	"./1.png": "./src/assets/images/dashboard-2/product/1.png",
	"./2.png": "./src/assets/images/dashboard-2/product/2.png",
	"./3.png": "./src/assets/images/dashboard-2/product/3.png"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/dashboard-2/product sync recursive ^\\.\\/.*\\.png$";